import axios from "axios";
// cookies
import Cookies from "js-cookie"
//引入进度条和进度条样式
import nProgress from 'nprogress';
import 'nprogress/nprogress.css'
import { getToken, getUsername, removeToken, removeUsername } from "./cookies";  // 这是封装好的方法
// 创建实例
const service = axios.create({
    baseURL: "",    // 请求地址
    timeout: 360000,  // 超时
});

// 拦截器
// 添加请求拦截器
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.headers["X-CSRFToken"] = Cookies.get("DjangoCookie")
    //开启进度条
    nProgress.start();
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    //进度条结束
    nProgress.done();
      return Promise.resolve(response);
}, function (error) {
      // 对响应错误做点什么
    // token失效自动退出
        removeToken();
        removeUsername();
    return Promise.reject(error);
});

// 暴露instance
export default service;
